import React, { useState } from 'react';
import mixpanel from 'lib/Analytics/Mixpanel';
import { useCheckSession } from 'components/Session';
import hasAccess from 'components/Helpers/brandHasAccess';
import { toNewCampaign } from 'constants/routes';
import { isAlternateCampaignDialogEnabled } from 'constants/alternateSignUp';
import AlternateSignUpDialog from 'components/Common/AlternateSignUpDialog';

const ModalDetails = ({ avatar, creator }) => {
  const [alternateDialogOpen, setAlternateDialogOpen] = useState(false);
  const hasSession = useCheckSession();
  const show = hasAccess();

  function trackTo(e) {
    e.preventDefault();
    if (mixpanel) {
      mixpanel.track('Onboarding from Content Modal', { first: hasSession });
    }
    if (isAlternateCampaignDialogEnabled) {
      setAlternateDialogOpen(true);
      return;
    }
    toNewCampaign();
  }

  return (
    <>
      {isAlternateCampaignDialogEnabled && (
        <AlternateSignUpDialog
          open={alternateDialogOpen}
          onClose={() => setAlternateDialogOpen(false)}
        />
      )}
      <div id="creator-details" className="creator-details">
        <div className="creator-container">
          <img src={avatar} alt="" />
          <span>
            <h4>{creator}</h4>
            <p>Start a content project to collect applications from creators like {creator}</p>
          </span>
        </div>
        {show && (
          <button className="u-button-reset" onClick={trackTo}>
            Start Content Project
          </button>
        )}
      </div>
    </>
  );
};

export default ModalDetails;
